import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isAdmin, isSupervisor } from "utils/utils";
import "./MobileExpenseTabs.scss";

/**
 * Pestañas Gastos / Aprobar gastos (solo supervisión). En empleados no se muestra.
 */
const MobileExpenseTabs = () => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const canSupervise = isAdmin() || isSupervisor();

	if (!canSupervise) {
		return null;
	}

	const isList = pathname === "/expenses";
	const isApprove = pathname === "/pending-expenses";
	const isApproved = pathname === "/approved-expenses";

	return (
		<div className="mobile-expense-tabs">
			<Link
				to="/expenses"
				className={`mobile-expense-tabs__tab ${isList ? "mobile-expense-tabs__tab--active" : ""}`}
			>
			{t("expenses.mobile.tabs.expenses")}
			</Link>
			<Link
				to="/pending-expenses"
				className={`mobile-expense-tabs__tab ${isApprove ? "mobile-expense-tabs__tab--active" : ""}`}
			>
			{t("expenses.mobile.tabs.approveExpenses")}
			</Link>
			<Link
				to="/approved-expenses"
				className={`mobile-expense-tabs__tab ${isApproved ? "mobile-expense-tabs__tab--active" : ""}`}
			>
			{t("expenses.mobile.tabs.approvedExpenses")}
			</Link>
		</div>
	);
};

export default MobileExpenseTabs;
